class Loadmore {
  constructor() {
    this.initialize()
  }

  initialize() {
    if(document.querySelector('.js-loadmore') == null) return 
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$loadmore = document.querySelector('.js-loadmore')
    this.ui.$loadmoreTarget = this.ui.$loadmore.querySelector('.js-loadmore-target')
    this.ui.$loadmoreBtn = this.ui.$loadmore.querySelector('.js-loadmore-button')
    this.totalPage = this.ui.$loadmoreBtn.getAttribute('data-total')
    this.nextPage = this.ui.$loadmoreBtn.getAttribute('href')
    this.currentPage = this.nextPage.split("/")
    this.currentPage = this.currentPage[this.currentPage.length-2]
  }

  bindEvents() {
    this.ui.$loadmoreBtn.addEventListener('click', this.onClick.bind(this))
  }

  onClick(e) {  
    e.preventDefault()

    fetch(this.nextPage)
    .then(res => {
      return res.text()
    })
    .then(html => {
      var parser = new DOMParser();
	    var doc = parser.parseFromString(html, 'text/html');

      const articles = doc.querySelectorAll('#article')
      
      for (let i = 0; i < articles.length; i++) {
        this.ui.$loadmoreTarget.append(articles[i])
      }
      
      window.animate.initialize()
    })
    .then(() => {
      if(this.currentPage < this.totalPage) {
        this.currentPage++
      } else {
        this.currentPage = this.totalPage
        this.ui.$loadmoreBtn.parentNode.remove()
      }
      
      this.nextPage = `${window.location.href}page/${this.currentPage}/`
      this.ui.$loadmoreBtn.setAttribute('href', this.nextPage)
    })
    .catch(err => {
      console.log(err)
    })
  }
}

export default Loadmore
